import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getAppSettingsRequest = {};
var _getAppSettingsResponse = {};
var _updateAppSettingsRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _updateAppSettingsResponse = {};
function resolveWixFilesharingApiV1SettingsAppSettingsServiceUrl(opts) {
    var domainToMappings = {
        'apps._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/file-sharing-server',
                destPath: '',
            },
        ],
        'filesharing._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
            {
                srcPath: '/api/v1',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/file-sharing-server',
                destPath: '/management-api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/file-sharing-server',
                destPath: '/management-api',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/file-sharing-server',
                destPath: '/management-api',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/file-sharing-server/_api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        _: [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Updates app settings with values specified by field mask */
export function updateAppSettings(payload) {
    var _a = serializer(_updateAppSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateAppSettingsResponse, {}).fromJSON;
    function __updateAppSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.settings',
            method: 'PATCH',
            methodFqn: 'wix.filesharing.api.v1.settings.AppSettingsService.UpdateAppSettings',
            url: resolveWixFilesharingApiV1SettingsAppSettingsServiceUrl({
                protoPath: '/api/v1/file-sharing/settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateAppSettings.fromReq = fromReq;
    __updateAppSettings.__isAmbassador = true;
    return __updateAppSettings;
}
/** Gets app settings of particular app installation in site. Returns default settings if not found. */
export function getAppSettings(payload) {
    var _a = serializer(_getAppSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppSettingsResponse, {}).fromJSON;
    function __getAppSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.settings',
            method: 'GET',
            methodFqn: 'wix.filesharing.api.v1.settings.AppSettingsService.GetAppSettings',
            url: resolveWixFilesharingApiV1SettingsAppSettingsServiceUrl({
                protoPath: '/api/v1/file-sharing/settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAppSettings.fromReq = fromReq;
    __getAppSettings.__isAmbassador = true;
    return __getAppSettings;
}
//# sourceMappingURL=http.impl.js.map